import { useMemo } from "react";
import { useQuery } from "urql";

import { ControlledSelectInputOption } from "@/components/FormInputs";
import { graphql } from "@/gen";
import { generateImageUrl } from "@/utils/image";

export const useAllFeedIconOptions: () => ControlledSelectInputOption[] = () => {
    const [fetchAllFeedIconsResult] = useQuery({
        query: graphql(`
            query fetchAllFeedIcons {
                fetchAllFeedIcons {
                    id
                    name
                    imageId
                }
            }
        `),
    });

    return useMemo(() => {
        const icons = fetchAllFeedIconsResult.data?.fetchAllFeedIcons ?? [];

        const options: ControlledSelectInputOption[] = icons.map(({ imageId, name }) => ({
            value: imageId,
            label: (
                <div className="flex items-center gap-4">
                    <img
                        src={generateImageUrl({ imageId, width: 100, height: 100 })}
                        alt={name}
                        height="20px"
                        width="20px"
                    />
                    <span>{name}</span>
                </div>
            ),
        }));

        return [{ value: null, label: "No icon" }, ...options];
    }, [fetchAllFeedIconsResult.data?.fetchAllFeedIcons]);
};
